import { withPrefix } from 'gatsby'
import React from 'react'
import { Link } from '../components/localizedlink'
// import Img from 'gatsby-image'
import marked from 'marked'
import { slugify }  from '../utils'

const SpeechDetail = ({ speaker, intervento, locale }) => (
  <section id="speech-detail" className={`section speech-detail ${slugify(intervento.tipologia)}`} aria-labelledby="region1">
    <div className="container">
      <div className="row" data-aos="fade-up">
        <div className="col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-2">
          <div className="row">
            <div className="col-sm-8 col-sm-push-4">
              <h1 id="region1" className="speech-detail__title">{intervento.title }</h1>
              <div className="speech-detail__day">{ intervento.day }, { intervento.orariodesc ? intervento.orariodesc : intervento.orario}</div>
              <div className="speech-detail__room">{intervento.luogo }</div>
              <div className="speech-detail__bodytext" dangerouslySetInnerHTML={{__html: marked(intervento.description)}}></div>
            </div>
            <div className="col-sm-4 col-sm-pull-8">
              <Link to={`/${slugify(speaker.title, locale)}/`} title={speaker.title} className="speech-detail__person">
                <figure className="speech-detail__figure">
                  <img src={withPrefix(speaker.img)} alt={speaker.title} className="speech-detail__img" />
                  <span className="speech-detail__icon"><span></span></span>
                </figure>
                <span className="speech-detail__program">{intervento.tipologia }</span>
                <span className="speech-detail__name">{speaker.title }</span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default SpeechDetail;
